import { checkIsInternalCompany } from 'app/auth/authUtils';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectCicFeeReasons = createSelector(getSystem, ({ cicFeeReasons }) => cicFeeReasons);

export const selectCicFeeReasonsItemsById = memoizeOne(id =>
  createSelector(selectCicFeeReasons, cicFeeReasons => {
    const { cicFeeReasonId, items } = cicFeeReasons[id] || {};

    if (!cicFeeReasonId) {
      return {};
    }

    return items?.reduce((acc, { cicFeeReasonId, ...item }) => {
      acc[item.feeTypeId] = item;

      return acc;
    }, {});
  }),
);

const selectCicFeeReasonsValues = createSelector(
  [selectCicFeeReasons, getIsFromInternalCompany],
  (feeReasons, isInternalCompany) =>
    Object.values(feeReasons).map(feeReason => ({
      ...feeReason,
      isGlobal: !isInternalCompany && checkIsInternalCompany(feeReason),
    })),
);

export const selectCicFeeReasonOptions = createSelector(selectCicFeeReasonsValues, cicFeeReasons =>
  cicFeeReasons.map(({ cicFeeReasonId, name, items, commentTemplates = [] }) => ({
    name,
    value: cicFeeReasonId,
    items,
    commentTemplates,
  })),
);

export const selectFilteredCicFeeReasons = createSelector(
  getDebouncedSearchValue,
  selectCicFeeReasonsValues,
  searchItems(feeReason => [feeReason.name]),
);

export const selectCICFeeReasonSchemaSchema = createSelector(
  getSystem,
  ({ cicFeeReasonSchema }) => cicFeeReasonSchema,
);
